<template>
    <div class="d-flex justify-content-center custom-padding" :class="{'faded-div-mobile' : $device.mobile, 'faded-div' : !$device.mobile}" ref="carouselContainer" :style="{gap: vertical ? '1px' : '20px' }">
        <VueSlickCarousel v-bind="settings" :slides-to-show="slideRange" :vertical="vertical" :variable-width="!vertical">
            <div v-for="(image, i) in images2" :key="i" :style="{padding: vertical ? '0 1px' : '0 10px'}">
                <img class="br" :src="$image(image)" :width="vertical ? '187' : 'auto'" :height="vertical ? 'auto' : '200px'">
            </div>
        </VueSlickCarousel>
        <VueSlickCarousel v-bind="settings" :slides-to-show="slideRange" :vertical="vertical" :variable-width="!vertical">
            <div v-for="(image, i) in images" :key="i" :style="{padding: vertical ? '0 1px' : '0 10px'}">
                <img class="br" :src="$image(image)" :width="vertical ? '187' : 'auto'" :height="vertical ? 'auto' : '200px'">
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>

import screen from '@/plugins/screen';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

export default {
    components: { VueSlickCarousel },
    mixins: [screen],
    data() {
        return {
            images: [
                'community/growing/growing1.png',
                'community/growing/growing2.png',
                'community/growing/growing3.png',
                'community/growing/growing19.png',
                'community/growing/growing5.png',
                'community/growing/growing7.png',
                'community/growing/growing17.png',
                'community/growing/growing10.png',
                'community/growing/growing11.png',
                'community/growing/growing20.png',
            ],
            images2: [
                'community/growing/growing8.png',
                'community/growing/growing6.png',
                'community/growing/growing12.png',
                'community/growing/growing9.png',
                'community/growing/growing13.png',
                'community/growing/growing11.png',
                'community/growing/growing14.png',
                'community/growing/growing15.png',
                'community/growing/growing16.png',
                'community/growing/growing18.png',
                'community/growing/growing4.png',
                'community/growing/growing21.png',
                'community/growing/growing22.png',
            ],
            settings: {
                arrows: false,
                dots: false,
                autoplay: true,
                speed: 2000,
                autoplaySpeed: 2000,
                cssEase: 'linear',
                slidesToScroll: 1,
            },
        };
    },
    computed: {
        slideRange() {
            return this.$device.desktop ? 4 : this.$device.tablet ? 3 : this.$device.mobile ? 3 : 3;
        },
        vertical() {
            return !!this.$device.mobile;
        },
    },
};
</script>

<style lang="scss" scoped>
    .custom-padding {
        padding: 4px 4px !important;
    }

    .slick-list {
        height: 1286px;
    }
    .br {
        border-radius: 8px;
    }
    .faded-div {
            padding: 0 0;
            position: relative;
            flex-direction: column;
            overflow: hidden;
        }

        .faded-div::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(to right, #f4f4f4, #422a2a00, #422a2a00, #422a2a00, #422a2a00, #422a2a00, #f4f4f4);
            z-index: 100;
            overflow: hidden;
        }

        .faded-div-mobile {
            position: relative;
            flex-direction: row;
            overflow: hidden;
        }
        @media (max-width: 768px) {

            .faded-div-mobile::before {
                content: "";
                position: absolute;
                padding: 0 0;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(to bottom, #f4f4f4, #422a2a00, #422a2a00, #422a2a00, #422a2a00, #422a2a00, #f4f4f4);
            z-index: 100;
        }
        }

</style>
